import { useAppSelector } from "@/lib/redux/hooks";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { Anchor } from "./styles";

import AppLinkComponent, {
  AppLinkProps,
  pageMatchesPath,
} from "@/components/AppLink";

// Cast to fix React 17 + @types/react 18 compatibility issue
const AppLink = AppLinkComponent as any;

export type InternalLinkProps = AppLinkProps & {
  title: string | null;
};

const InternalLink: React.FC<InternalLinkProps> = (props) => {
  const { title, page, params } = props;

  const menuIsOpen = useAppSelector((state) => state.desktopMenu.isOpen);

  const { asPath } = useRouter();
  const isCurrentPage = pageMatchesPath(page, asPath);

  return (
    <AppLink page={page} params={params}>
      <Anchor
        $isActive={isCurrentPage}
        $menuIsOpen={menuIsOpen}
        aria-current={isCurrentPage ? "page" : "false"}
      >
        {title}
      </Anchor>
    </AppLink>
  );
};

export default InternalLink;
